import React from "react";
import { LazyLoading } from "../../controls/LazyLoading/LazyLoading";

export const CenteredLazyLoading = () => {
	return (
		<div
			style={{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<LazyLoading />
		</div>
	);
};
